module.exports = new __parcel__URL__("virtual-agent-ai-answers-app-skeleton.tpl.283eb0a3.svg").toString();